import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_ROOT = `${BACKEND_URL}/api`;

// Shared axios instance. httpOnly cookie auth carries via withCredentials.
export const api = axios.create({
  baseURL: API_ROOT,
  withCredentials: true,
  timeout: 15000,
});

// Global 402 → paywall redirect. The backend gates every gameplay and
// content-read route with get_current_premium_parent, which returns
//   HTTP 402 { detail: { status: "payment_required", checkoutUrl: "/parent/purchase" } }
// The interceptor bounces the browser to the checkout URL exactly once
// per navigation so we don't flood history with duplicate entries.
let _paywallBouncing = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 402 && detail && detail.status === "payment_required") {
      const target = detail.checkoutUrl || "/parent/purchase";
      if (!_paywallBouncing && typeof window !== "undefined" && window.location.pathname !== target) {
        _paywallBouncing = true;
        try { window.location.replace(target); }
        finally { setTimeout(() => { _paywallBouncing = false; }, 1500); }
      }
    }
    return Promise.reject(err);
  },
);

// Convert FastAPI error detail (string / array / object) into a plain string.
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function newIdempotencyKey() {
  // Prefer crypto.randomUUID when available, fall back to Math.random.
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "id-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}
